import { moveInlineStylesToHead } from './content-security-policy';

export function startObserving(element, observer) {
	observer = new MutationObserver(function (mutationsList) {
		for (const mutation of mutationsList) {
			if (
				mutation.type === 'attributes' &&
				mutation.attributeName === 'style'
			) {
				moveInlineStylesToHead(element.id);
			}
		}
	});
	observer.observe(element, { attributes: true, subtree: true });
}

export function stopObserving(observer) {
	if (observer) {
		observer.disconnect();
		observer = null;
	}
}
